// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.userRoleForm {
  display: flex;
  flex-direction: column;
  gap: 0;
  color: var(--text-body, #334155);
}

.userRoleForm-section {
  padding: 14px 0;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
}

.userRoleForm-section--first,
.userRoleForm-section--parentCompact {
  padding-top: 0;
}

.userRoleForm-section--parentCompact {
  border-bottom: 0;
}

.userRoleForm-sectionHead {
  margin-bottom: 8px;
}

.userRoleForm-sectionHead > span,
.userRoleForm-label {
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.userRoleForm-sectionHead p,
.userRoleForm-hint {
  margin: 4px 0 0;
  color: var(--text-subtle, #94a3b8);
  font-size: 12px;
  font-weight: 600;
}

.userRoleForm-roleStrip {
  padding: 0 0 12px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  margin-bottom: 14px;
}

.userRoleForm-roleChip {
  min-height: 28px;
  padding: 0 11px;
  border: 1px solid #b8ddf5;
  border-radius: var(--radius-pill, 999px);
  background: #eef8ff;
  color: var(--brand-primary, #227ebd);
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 12px;
  font-weight: 800;
}

.userRoleForm-roleChipDot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
  flex: 0 0 auto;
}

.userRoleForm-roleChoices {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.userRoleForm-roleChoice {
  min-height: 32px;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-pill, 999px);
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 650;
  cursor: pointer;
}

.userRoleForm-roleChoice:hover {
  border-color: var(--border-brand, #6fb1df);
  background: var(--blue-50, #eef8ff);
}

.userRoleForm-roleChoice[data-selected='true'] {
  border-color: var(--brand-primary, #227ebd);
  background: var(--brand-primary, #227ebd);
  color: #fff;
}

.userRoleForm-roleChoiceDot {
  width: 7px;
  height: 7px;
  flex: 0 0 7px;
  border-radius: 50%;
  background: currentColor;
  opacity: 0.75;
}

.userRoleForm-grid {
  display: grid;
  gap: 10px;
}

.userRoleForm-grid--two {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.userRoleForm-grid--three {
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) 92px;
  align-items: start;
  margin-bottom: 10px;
}

.userRoleForm-grid--three .userRoleForm-field {
  margin-bottom: 0;
}

.userRoleForm-field {
  margin: 0 0 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.userRoleForm-field:last-child {
  margin-bottom: 0;
}

.userRoleForm-grid--three .userRoleForm-select {
  height: 38px;
}

.userRoleForm-select,
.userRoleForm-autocomplete input,
.userRoleForm-autocomplete .form-control {
  min-height: 38px;
  width: 100%;
  border: 1px solid var(--border-subtle, #dbe4ee);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #ffffff);
  color: var(--text-body, #334155);
  padding: 0 10px;
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
  font-size: 14px;
  font-weight: 650;
  box-shadow: none;
}

.userRoleForm-autocomplete {
  width: 100%;
  margin: 0 !important;
}

.userRoleForm-select:focus,
.userRoleForm-autocomplete input:focus,
.userRoleForm-autocomplete .form-control:focus {
  outline: none;
  border-color: var(--border-brand, #6fb1df);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));
}

.userRoleForm-preview {
  margin-top: 8px;
  padding: 10px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-lg, 12px);
  background: var(--slate-25, #fbfdff);
  display: flex;
  align-items: center;
  gap: 10px;
}

.userRoleForm-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #e8f2fb;
  color: var(--brand-primary, #227ebd);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 800;
  line-height: 1;
  flex: 0 0 34px;
  overflow: hidden;
}

.userRoleForm-avatar > span {
  display: block;
  line-height: 1;
  transform: translateY(0.5px);
}

.userRoleForm-preview strong,
.userRoleForm-preview div > span {
  display: block;
}

.userRoleForm-preview strong {
  color: var(--text-heading, #0f172a);
  font-size: 14px;
  font-weight: 800;
  line-height: 1.25;
}

.userRoleForm-preview div > span {
  margin-top: 2px;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 650;
  line-height: 1.25;
}

.userRoleForm-chipList {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.userRoleForm-chip {
  min-height: 26px;
  padding: 0 5px 0 10px;
  border-radius: var(--radius-pill, 999px);
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: #e8f7ee;
  color: #268049;
  font-size: 12px;
  font-weight: 750;
}

.userRoleForm-chip i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #268049;
}

.userRoleForm-chip button {
  width: 18px;
  height: 18px;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: inherit;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 15px;
  line-height: 1;
}

.userRoleForm-chip button:hover {
  background: rgba(15, 23, 42, 0.08);
}

.userRoleForm-empty {
  min-height: 24px;
  display: inline-flex;
  align-items: center;
  color: var(--text-subtle, #94a3b8);
  font-size: 12px;
  font-weight: 650;
}

.userRoleForm-empty--sports {
  width: 100%;
  min-height: auto;
  padding: 9px 11px;
  border-radius: var(--radius-md, 8px);
  background: var(--slate-50, #f8fafc);
  line-height: 1.45;
}

.userRoleForm-studentOption {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
  padding: 2px 0;
}

.userRoleForm-studentOption strong {
  overflow: hidden;
  color: var(--text-strong, #0f172a);
  font-size: 13px;
  font-weight: 750;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.userRoleForm-studentOption span {
  color: var(--text-muted, #64748b);
  font-size: 11.5px;
  font-weight: 500;
  line-height: 1.35;
  white-space: normal;
}

.userRoleForm-error,
.userRoleForm-alert {
  color: #b42318;
  font-size: 12px;
  font-weight: 700;
}

.userRoleForm-alert {
  margin-top: 10px;
  padding: 10px 12px;
  border: 1px solid #fecdca;
  border-radius: var(--radius-md, 8px);
  background: #fff4f2;
}

.userRoleForm-actions {
  padding-top: 14px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

@media (max-width: 720px) {
  .userRoleForm-grid--three {
    grid-template-columns: 1fr 1fr;
  }

  .userRoleForm-grid--three .userRoleForm-field:last-child {
    grid-column: 1 / -1;
  }
}

@media (max-width: 620px) {
  .userRoleForm-grid--two,
  .userRoleForm-grid--three {
    grid-template-columns: 1fr;
  }

  .userRoleForm-grid--three .userRoleForm-field:last-child {
    grid-column: auto;
  }

  .userRoleForm-actions {
    flex-direction: column-reverse;
  }

  .userRoleForm-actions .people-btn {
    width: 100%;
  }
}

.userRoleForm-intro {
  margin: 0 0 12px;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  line-height: 1.5;
}
.userRoleForm-summary {
  min-height: 44px;
  margin-bottom: 14px;
  padding: 10px 12px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 8px;
  background: var(--slate-50, #f8fafc);
  color: var(--text-body, #334155);
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminView/Users/AllUsers/UserAddRoleForm/UserAddRoleForm.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,sDAAsD;AACxD;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,wCAAwC;EACxC,mBAAmB;EACnB,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,wCAAwC;EACxC,qCAAqC;EACrC,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,yDAAyD;EACzD,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,gBAAgB;EAChB,WAAW;EACX,+CAA+C;EAC/C,oCAAoC;EACpC,wCAAwC;EACxC,gCAAgC;EAChC,eAAe;EACf,mEAAmE;EACnE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;;;EAGE,aAAa;EACb,0CAA0C;EAC1C,mEAAmE;AACrE;;AAEA;EACE,eAAe;EACf,aAAa;EACb,+CAA+C;EAC/C,qCAAqC;EACrC,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,4BAA4B;AAC9B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,+CAA+C;EAC/C,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".userRoleForm {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  color: var(--text-body, #334155);\n}\n\n.userRoleForm-section {\n  padding: 14px 0;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.userRoleForm-section--first,\n.userRoleForm-section--parentCompact {\n  padding-top: 0;\n}\n\n.userRoleForm-section--parentCompact {\n  border-bottom: 0;\n}\n\n.userRoleForm-sectionHead {\n  margin-bottom: 8px;\n}\n\n.userRoleForm-sectionHead > span,\n.userRoleForm-label {\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.userRoleForm-sectionHead p,\n.userRoleForm-hint {\n  margin: 4px 0 0;\n  color: var(--text-subtle, #94a3b8);\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.userRoleForm-roleStrip {\n  padding: 0 0 12px;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  margin-bottom: 14px;\n}\n\n.userRoleForm-roleChip {\n  min-height: 28px;\n  padding: 0 11px;\n  border: 1px solid #b8ddf5;\n  border-radius: var(--radius-pill, 999px);\n  background: #eef8ff;\n  color: var(--brand-primary, #227ebd);\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.userRoleForm-roleChipDot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: currentColor;\n  flex: 0 0 auto;\n}\n\n.userRoleForm-roleChoices {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.userRoleForm-roleChoice {\n  min-height: 32px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-pill, 999px);\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.userRoleForm-roleChoice:hover {\n  border-color: var(--border-brand, #6fb1df);\n  background: var(--blue-50, #eef8ff);\n}\n\n.userRoleForm-roleChoice[data-selected='true'] {\n  border-color: var(--brand-primary, #227ebd);\n  background: var(--brand-primary, #227ebd);\n  color: #fff;\n}\n\n.userRoleForm-roleChoiceDot {\n  width: 7px;\n  height: 7px;\n  flex: 0 0 7px;\n  border-radius: 50%;\n  background: currentColor;\n  opacity: 0.75;\n}\n\n.userRoleForm-grid {\n  display: grid;\n  gap: 10px;\n}\n\n.userRoleForm-grid--two {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.userRoleForm-grid--three {\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) 92px;\n  align-items: start;\n  margin-bottom: 10px;\n}\n\n.userRoleForm-grid--three .userRoleForm-field {\n  margin-bottom: 0;\n}\n\n.userRoleForm-field {\n  margin: 0 0 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.userRoleForm-field:last-child {\n  margin-bottom: 0;\n}\n\n.userRoleForm-grid--three .userRoleForm-select {\n  height: 38px;\n}\n\n.userRoleForm-select,\n.userRoleForm-autocomplete input,\n.userRoleForm-autocomplete .form-control {\n  min-height: 38px;\n  width: 100%;\n  border: 1px solid var(--border-subtle, #dbe4ee);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #ffffff);\n  color: var(--text-body, #334155);\n  padding: 0 10px;\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n  font-size: 14px;\n  font-weight: 650;\n  box-shadow: none;\n}\n\n.userRoleForm-autocomplete {\n  width: 100%;\n  margin: 0 !important;\n}\n\n.userRoleForm-select:focus,\n.userRoleForm-autocomplete input:focus,\n.userRoleForm-autocomplete .form-control:focus {\n  outline: none;\n  border-color: var(--border-brand, #6fb1df);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));\n}\n\n.userRoleForm-preview {\n  margin-top: 8px;\n  padding: 10px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-lg, 12px);\n  background: var(--slate-25, #fbfdff);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.userRoleForm-avatar {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  background: #e8f2fb;\n  color: var(--brand-primary, #227ebd);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 800;\n  line-height: 1;\n  flex: 0 0 34px;\n  overflow: hidden;\n}\n\n.userRoleForm-avatar > span {\n  display: block;\n  line-height: 1;\n  transform: translateY(0.5px);\n}\n\n.userRoleForm-preview strong,\n.userRoleForm-preview div > span {\n  display: block;\n}\n\n.userRoleForm-preview strong {\n  color: var(--text-heading, #0f172a);\n  font-size: 14px;\n  font-weight: 800;\n  line-height: 1.25;\n}\n\n.userRoleForm-preview div > span {\n  margin-top: 2px;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 650;\n  line-height: 1.25;\n}\n\n.userRoleForm-chipList {\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.userRoleForm-chip {\n  min-height: 26px;\n  padding: 0 5px 0 10px;\n  border-radius: var(--radius-pill, 999px);\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  background: #e8f7ee;\n  color: #268049;\n  font-size: 12px;\n  font-weight: 750;\n}\n\n.userRoleForm-chip i {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #268049;\n}\n\n.userRoleForm-chip button {\n  width: 18px;\n  height: 18px;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: inherit;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 15px;\n  line-height: 1;\n}\n\n.userRoleForm-chip button:hover {\n  background: rgba(15, 23, 42, 0.08);\n}\n\n.userRoleForm-empty {\n  min-height: 24px;\n  display: inline-flex;\n  align-items: center;\n  color: var(--text-subtle, #94a3b8);\n  font-size: 12px;\n  font-weight: 650;\n}\n\n.userRoleForm-empty--sports {\n  width: 100%;\n  min-height: auto;\n  padding: 9px 11px;\n  border-radius: var(--radius-md, 8px);\n  background: var(--slate-50, #f8fafc);\n  line-height: 1.45;\n}\n\n.userRoleForm-studentOption {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 3px;\n  padding: 2px 0;\n}\n\n.userRoleForm-studentOption strong {\n  overflow: hidden;\n  color: var(--text-strong, #0f172a);\n  font-size: 13px;\n  font-weight: 750;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.userRoleForm-studentOption span {\n  color: var(--text-muted, #64748b);\n  font-size: 11.5px;\n  font-weight: 500;\n  line-height: 1.35;\n  white-space: normal;\n}\n\n.userRoleForm-error,\n.userRoleForm-alert {\n  color: #b42318;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.userRoleForm-alert {\n  margin-top: 10px;\n  padding: 10px 12px;\n  border: 1px solid #fecdca;\n  border-radius: var(--radius-md, 8px);\n  background: #fff4f2;\n}\n\n.userRoleForm-actions {\n  padding-top: 14px;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n@media (max-width: 720px) {\n  .userRoleForm-grid--three {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .userRoleForm-grid--three .userRoleForm-field:last-child {\n    grid-column: 1 / -1;\n  }\n}\n\n@media (max-width: 620px) {\n  .userRoleForm-grid--two,\n  .userRoleForm-grid--three {\n    grid-template-columns: 1fr;\n  }\n\n  .userRoleForm-grid--three .userRoleForm-field:last-child {\n    grid-column: auto;\n  }\n\n  .userRoleForm-actions {\n    flex-direction: column-reverse;\n  }\n\n  .userRoleForm-actions .people-btn {\n    width: 100%;\n  }\n}\n\n.userRoleForm-intro {\n  margin: 0 0 12px;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  line-height: 1.5;\n}\n.userRoleForm-summary {\n  min-height: 44px;\n  margin-bottom: 14px;\n  padding: 10px 12px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 8px;\n  background: var(--slate-50, #f8fafc);\n  color: var(--text-body, #334155);\n  display: flex;\n  align-items: center;\n  font-size: 13px;\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
